import React from 'react'

export default function AccountNotices({
  accountNoticesData, accountsPath, canUnlockBillingProfile, duplicateAccounts, flashMessageRef, setAccountNoticesData, setLoading, unlockBillingProfilePath, migrationStatus
}) {
  const unlockBillingProfile = () => {
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: unlockBillingProfilePath,
      dataType: 'json',
      success: res => {
        setLoading(false)
        flashMessageRef.current.show(res.message)
        setAccountNoticesData(prevState => ({
          ...prevState,
          lockedByCardRejections: false
        }))
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  return (
    <>
      { duplicateAccounts.length > 0 &&
        <div 
          className='card-panel flex-box items-start m-t-10'
          style={{ backgroundColor: '#fc0' }}
        >
          <i 
            className='fa-light fa-building-magnifying-glass m-r-5' 
            style={{ color: '#222' }}
          />

          <div 
            className='m-l-10'
            style={{ color: '#222' }}
          >
            We have found more than one matching accounts for this client's email.
            
            <div className='flex-box flex-column'>
              { duplicateAccounts.map((acc, idx) => (
                <a
                  key={ idx }
                  href={ `${ accountsPath }/${ acc.apiUid }` }
                  target='_blank'
                  style={{ color: '#222', textDecoration: 'underline' }}
                >
                  Account ID: { acc.id }
                </a>
              ))}
            </div>
          </div>
        </div>
      }

      { migrationStatus && 
        <div className="card-panel flex-box items-center m-t-10" style={{ backgroundColor: '#fc0' }}>
          <i className='fa-light fa-swap m-r-5' />
          <div className='m-l-10'>
            { migrationStatus === 'in_progress' ? <>Moving account...</> : <>Account has been successfully moved</> }
          </div>
        </div>
      }

      { accountNoticesData.consideredFake && 
        <div className="card-panel red flex-box items-center m-t-10">
          <i className='fa-circle-exclamation m-r-5' />
          <div className='m-l-10'>
            This account has been marked as unsafe.
          </div>
        </div>
      }

      { accountNoticesData.lockedByCardRejections && !migrationStatus && 
        <div className="card-panel yellow flex-box items-center m-t-10">
          <i className='fa-light fa-credit-card m-r-5' style={{ color: '#fff' }} />
          <div className='m-l-10' style={{ color: '#fff' }}>
            The client has made 5 unsuccessful card entries. Their billing profile has been locked.
          </div>

          { canUnlockBillingProfile &&
            <div 
              className='flex-box content-end'
              style={{ marginLeft: 'auto' }}
            >
              <div
                className='btn flex-box items-center content-center'
                style={{ cursor: 'pointer' }}
                onClick={ unlockBillingProfile }
              >
                <i className='fa-light fa-unlock m-r-10' />
                <span>
                  Unlock
                </span>
              </div>
            </div>
          }
        </div>
      }
    </>
  )
}